import React, { useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link, useLocation } from 'react-router-dom';
import * as Routes from '../../../constants/Routes';
import ProtectedSection from '../../ProtectedSection';
import Roles from '../../../constants/Roles';
import { ViewArray } from '@material-ui/icons';

export default function DoorsAdminMenuItem() {
  const location = useLocation();
  return (
    <ProtectedSection roles={[Roles.SuperUser]}>
      <ListItem
        button
        component={Link}
        to={Routes.DoorsAdmin}
        selected={location.pathname.startsWith(Routes.DoorsAdmin) || location.pathname.startsWith(Routes.ViewDoor)}
      >
        <ListItemIcon>
          <ViewArray />
        </ListItemIcon>
        <ListItemText primary="Doors" />
      </ListItem>
    </ProtectedSection>
  );
}
